import type { OwaDate } from 'owa-datetime';
import { action } from 'satcheljs';

/**
 * Shows the calendar surface context menu
 */
let showSurfaceContextMenu = action(
    'showSurfaceContextMenu',
    (
        start: OwaDate,
        end: OwaDate,
        isAllDay: boolean,
        clickEvent: MouseEvent,
        selectedCalendarFolderId?: string
    ) => ({
        start: start,
        end: end,
        isAllDay: isAllDay,
        clickEvent: clickEvent,
        selectedCalendarFolderId: selectedCalendarFolderId,
    })
);

export default showSurfaceContextMenu;
